import { createSlice } from '@reduxjs/toolkit';

const campaignScrollSlice = createSlice({
  name: 'campaignScroll',
  initialState: {
    preview: null,
    edit: null,
  },
  reducers: {
    setScrollPosition: (state, { payload }) => ({
      ...state,
      [payload.page]: payload.scrollPosition,
    }),
    resetScrollPosition: () => ({
      preview: null,
      edit: null,
    }),
  },
});

export const {
  setScrollPosition,
  resetScrollPosition,
} = campaignScrollSlice.actions;
export default campaignScrollSlice.reducer;
